export default __webpack_public_path__ + "static/media/yellow-gas-tanker.982cd5e4.svg";